import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'ineligible-next-steps',
  styleUrl: 'ineligible-next-steps.css',
})
export class IneligibleNextSteps {
  @Prop() localDealerUrl: string = '';
  @Prop() placeAdUrl: string = '';
  @Prop() startBrowsingUrl: string = '';
  @Prop() vehicleName: string = '';

  render() {
    return (
      <div class="mb-14 text-center">
        <div class="font-bold text-xl mb-1">Start the Trade-in Process Online</div>
        <div class="mb-4 text-sm">We can connect you with a local dealership about your car - and a no-obligation quote for your next one.</div>
        <div class="mb-1 text-sm">Your Trade-in:</div>
        <div class="font-bold mb-4 text-sm">{this.vehicleName}</div>
        <div class="flex justify-center">
          <div class="xs:w-3/4 md:w-64">
            <ico-button label="See Local Dealers" url={this.localDealerUrl} target="_blank" />
          </div>
        </div>

        <hr class="my-10" />

        <div class="font-bold text-xl mb-1">Sell Your Car Yourself</div>
        <div class="mb-4 text-sm">Reach serious shoppers on Autotrader and KBB.com - for one low price.</div>

        <div class="text-center flex justify-center">
          <div class="xs:w-3/4 md:w-64">
            <ico-button buttonStyle="tertiary" url={this.placeAdUrl} label="Place an Ad" target="_blank" />
          </div>
        </div>

        <hr class="my-10" />

        <div class="font-bold text-xl mb-1">Shop for Your Next Car</div>
        <div class="mb-4 text-sm">See trusted pricing, get reviews and find the car in stock near you.</div>

        <div class="text-center flex justify-center">
          <div class="xs:w-3/4 md:w-64">
            <ico-button buttonStyle="tertiary" url={this.startBrowsingUrl} label="Start Browsing" target="_blank" />
          </div>
        </div>

        <hr class="my-10" />
      </div>
    );
  }
}
